import { RootState } from '../root-reducer';

export const userMediaAssetsSelector = (state: RootState) => state.userMedia?.assets ?? [];
export const userMediaPaginationSelector = (state: RootState) => state.userMedia?.pagination ?? null;
export const userMediaLoadingSelector = (state: RootState) => Boolean(state.userMedia?.loading);
export const userMediaLoadingMoreSelector = (state: RootState) => Boolean(state.userMedia?.loadingMore);
export const userMediaListCacheAtSelector = (state: RootState) => state.userMedia?.listCacheAt ?? {};
export const userMediaListSettledSelector = (state: RootState) => Boolean(state.userMedia?.listSettled);
export const userMediaExhaustedSelector = (state: RootState) => Boolean(state.userMedia?.exhausted);
export const userMediaErrorSelector = (state: RootState) => state.userMedia?.error ?? null;
export const userMediaMutatingAssetIdSelector = (state: RootState) => state.userMedia?.mutatingAssetId ?? null;
